import React, { FC } from 'react';
import { faCopy, faPen, faSave, faXmark } from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { EIconButtonColorSchema, EIconButtonTypeSchema, IconButton } from '../../Common/Buttons/IconButton';
import { useAlert } from '../../../tools/hooks';
import { fontSizeAndHeight } from '../../../styleHelpers/fontSizes';
import { EAlertType } from '../../../entities/IAlert';
import IntlMessage from '../../Common/IntlMessage';
import { IProfileReducer } from '../../../reducers/profileReducer';
import { IState } from '../../../reducers';

const ButtonContainer = styled.div`
    justify-content: flex-end;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    > div {
        font-weight: 500;
        ${fontSizeAndHeight[13]};
        display: flex;
        flex-direction: column;
        align-items:center;
        margin-left: .5rem;
        button {
            margin-bottom: 0.5rem;
        }
    }
`;

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
`;

interface IProps {
    loading: boolean;
    cancelLoading: boolean;
    editMode: boolean;
    profileContextEditMode: boolean;
    contextMenuButton?: boolean;
    whiteBackground?: boolean;
    disabledSave?: boolean;
    disabledEdit?: boolean;
    onSave();
    onCancel();
    changeEditMode();
}

export const CommonButtonsComponent: FC<React.PropsWithChildren<IProps>> = (props) => {
    const addAlert = useAlert();
    const { currentUserPermissions } = useSelector<IState, IProfileReducer>(state => ({ ...state.profile }));

    const copyUrl = () => {
        const currentURL = window.location.href;
        const tempInput = document.createElement('input');
        tempInput.value = currentURL;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);
        addAlert(<IntlMessage id="cluster.alert.urlCopied" />, EAlertType.SUCCESS);
    };

    return (
        <ButtonWrapper>
            <ButtonContainer>
                {props.editMode &&
                    <>
                        <div>
                            <IconButton icon={faSave} onClick={props.onSave} disabled={props.loading || props.cancelLoading || props.disabledSave} />
                            <IntlMessage id="global.save" />
                        </div>
                        <div>
                            <IconButton typeSchema={EIconButtonTypeSchema.SECONDARY} colorSchema={EIconButtonColorSchema.ALERT} icon={faXmark} onClick={props.onCancel} disabled={props.loading || props.cancelLoading} />
                            <IntlMessage id="global.cancel" />
                        </div>
                    </>
                }
                {!props.editMode &&
                    <div>
                        <IconButton typeSchema={EIconButtonTypeSchema.SECONDARY} icon={faPen} onClick={props.changeEditMode} disabled={props.editMode || props.disabledEdit || !(currentUserPermissions['Users.OnBehalf.Edit'] || currentUserPermissions['Users.Edit'])} />
                        <IntlMessage id="global.edit" />
                    </div>
                }
                {props.contextMenuButton &&
                    <div>
                        <IconButton typeSchema={EIconButtonTypeSchema.SECONDARY} icon={faCopy} onClick={copyUrl} disabled={props.loading || props.cancelLoading} />
                        <IntlMessage id="profile.mainInformations.contextMenu.copyLink" />
                    </div>

                }
            </ButtonContainer>
        </ButtonWrapper>
    );
};
